import { atom, selector } from "recoil"
import {
  WatchPartyHistoryLinkAction,
  WatchPartyHistoryLinkProps
} from "./types"

export const watchPartyHistoryLinksAtom = atom<WatchPartyHistoryLinkProps[]>({
  key: "watchPartyHistoryLinksAtom",
  default: []
})

export const watchPartyHistoryLinksSelector = selector({
  key: "watchPartyHistoryLinksSelector",
  get: ({ get }) => {
    return get(watchPartyHistoryLinksAtom)
  },
  set: ({ set, get }, action) => {
    //@ts-ignore
    //TODO need fix type
    const { payload, type } = action as WatchPartyHistoryLinkAction

    if (type === "DOWNLOAD") {
      set(watchPartyHistoryLinksAtom, prev => [...prev, ...payload])
    }

    if (type === "ADD") {
      set(watchPartyHistoryLinksAtom, (prevList) => {
        // Remove the data if present 
        const freshList = prevList.filter(item => item.id !== payload.id)
        return [...freshList, payload]  // Append new payload at end
      })
    }
    if (type === "DELETE") {
      set(watchPartyHistoryLinksAtom, prev =>
        prev.filter(el => el.id !== payload.id)
      )
    }

    if (type === "RESET") {
      set(watchPartyHistoryLinksAtom, [])
    }
  }
})

export const middlewareWatchPartyHistoryLinks =
  ({ type, payload }) =>
  (oldValue: WatchPartyHistoryLinkProps[]) => {
    if (type === "DOWNLOAD") {
      return [...oldValue, ...payload]
    }

    if (type === "ADD") {
      return [...oldValue, payload]
    }
    if (type === "DELETE") {
      return oldValue.filter(el => el.id !== payload.id)
    }

    if (type === "RESET") {
      return []
    }
  }
